import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    FormControl,
    FormControlLabel,
    FormLabel,
    Radio,
    RadioGroup,
    Stack,
    DialogTitle,
} from '@mui/material';
import {useMutation} from 'react-query';
import {enqueueSnackbar} from 'notistack';
import axiosClient from '../../../../../../../../lib/axios';
import {useState} from 'react';

export default function DialogImprimirFaturas({open, id, onClose, handleImprimir,}: DialogImprimirFaturasProps) {
    const [printOption, setPrintOption] = useState<'pdf' | 'zip'>('pdf');
    const [nomenclature, setNomenclature] = useState<'nome_publico' | 'codigo_publico'>('codigo_publico');
    const isPdf: boolean = printOption === 'pdf';

    // Mutation para baixar as faturas
    const {mutate: downloadAllInvoices} = useMutation({
        mutationKey: 'download-all-invoices',
        mutationFn: async () => {
            const response = await axiosClient.get(`/financeiro/conta-corrente-consumo/baixar-todas-faturas`, {
                params: {
                    id: id,
                    tipo_impressao: printOption,
                    nomenclatura: nomenclature,
                },
                responseType: 'blob',
            });

            const fileName = (isPdf && `faturas-${id}.pdf`) || `faturas-${id}.zip`;
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            return response.data;
        },
        onSuccess: () => {
            enqueueSnackbar('Fatura Gerada com sucesso', {variant: 'success'});
            handleImprimir();
        },
        onError: (error) => {
            console.error('Erro ao baixar os arquivos', error);
            enqueueSnackbar('Erro ao baixar os arquivos', {variant: 'error'});
        },
    });

    // Função manipuladora para iniciar o download
    const handlePrintAll = () => {
        downloadAllInvoices();
    };

    return (
        <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
            <DialogTitle>Imprimir Faturas</DialogTitle>
            <DialogContent>
                <FormControl component="fieldset" fullWidth sx={{mt: 2}}>
                    <FormLabel
                        id="print-option-group-label"
                        sx={{color: 'text.primary', fontWeight: 'bold', mb: 1}}
                    >
                        Opção de Impressão
                    </FormLabel>
                    <RadioGroup
                        row
                        aria-labelledby="print-option-group-label"
                        name="print-option"
                        value={printOption}
                        onChange={(e) => setPrintOption(e.target.value as 'pdf' | 'zip')}
                    >
                        <Stack direction="row" spacing={3} width="100%">
                            <FormControlLabel
                                value="pdf"
                                control={<Radio color="success"/>}
                                label="PDF Unificado"
                            />
                            <FormControlLabel
                                value="zip"
                                control={<Radio color="success"/>}
                                label="Arquivo ZIP"
                            />
                        </Stack>
                    </RadioGroup>
                </FormControl>

                <FormControl component="fieldset" fullWidth sx={{mt: 2}}>
                    <FormLabel
                        id="nomenclature-option-group-label"
                        sx={{color: 'text.primary', fontWeight: 'bold', mb: 1}}
                    >
                        { (isPdf && 'Ordenação dos arquivos' ) || 'Nomeclatura dos arquivos' }
                    </FormLabel>
                    <RadioGroup
                        aria-labelledby="nomenclature-option-group-label"
                        name="nomenclature-option"
                        value={nomenclature}
                        onChange={(e) => setNomenclature(e.target.value as 'nome_publico' | 'codigo_publico')}
                    >
                        <Stack direction="row" spacing={3} width="100%">
                            <FormControlLabel
                                value="codigo_publico"
                                control={<Radio color="success"/>}
                                label={ (isPdf && 'Dados do público') || 'Dados do público + nome' }
                            />
                            <FormControlLabel
                                value="nome_publico"
                                control={<Radio color="success"/>}
                                label="Nome do público"
                            />
                        </Stack>
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" onClick={onClose}>
                    Cancelar
                </Button>
                <Button color="success" variant="contained" onClick={handlePrintAll}>
                    Imprimir
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface DialogImprimirFaturasProps {
    open: boolean;
    id: number;
    onClose: () => void;
    handleImprimir: () => void;
}